var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "telephone",
    width: 18,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYEAQAAAAa7ikwAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAGAAAABgAPBrQs8AAAAHdElNRQflBwUMEwf5MiHmAAACTklEQVRIx62Wzyv7cRzHP9tn5YSolRxc/MxB3IbSSHEhbVicpOYwygclodSSww7SlFKSJOXgvPwHlJOyOKhJ2RxkMzFbvR8O7+83Pttss+19fP14Pl/P1+v9fn0+ivLvgKoiNjbg+RlubqC/XynWAVWF42MIBhEjI+B2QzwODkcRwA0GODqCYBCamr7tLpckGR0tkGBqCsLhn+DfvulpiMcRw8P5E4jzc1ha+r0ATUO8vSFqavJUEAohBgYyx9zfw/h4PvhGRYlGFUNZ2e/gdruiVFUpXF7m2aLTU9jeTg9us8HnJ7hceYFLAqcTcXcHBoMevLNTDnhmJm9wSWA2QyyG6O1Nbg1EIlBZWRCBBDs4AJ9Pb1NVuL6GnZ3CCUR9vXxU3d16EotF2u32IqjwesHvR5SU6O2aBh8f0NNToIrSUggEEB5PKrnbDdEoWCzpi2tsBIcDqquzqLBaZUsGB1N9W1vw/g6Tk3r77KzMCYUgHEb09WUhWVyUu6m1NVWl0ynbtb8PFRWwsCDfic0mc9fWpD/DqpfbdXdXrpC6ulR/W5u8Xa+vElyvFrG6mgOJqsLJCTw8IFpaUpWYTDA2Bu3t6ef5n6SjI8PQTSbY24NIJGtf0xbp9cLFRQ6BKyuQSCA8nuQrnDlvYgICgdyCRVcXBAJwdZW8UtKDNzfD0xMsL+cuWZSXIzY35WB9PrBa08c1NMDjo1w/RuNfW6tAbS0cHkIsBn4/rK/D0JDcvpoGLy/yG6+qfwbXV2o2w9wcnJ3JH4ZEAm5vYX7+Z+Vf9HYK4bocIsgAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjEtMDctMDVUMTI6MTk6MDcrMDA6MDAuvMrWAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIxLTA3LTA1VDEyOjE5OjA3KzAwOjAwX+FyagAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.f7ecd7c0c69a3c748f70b4915f390e87.svg";
export { ForwardRef as ReactComponent };